
import { defineComponent } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import AcademicPerformanceGradesContent from "./Components/AcademicPerformanceGradesContent.vue";

export default defineComponent({
  name: "AcademicPerformanceGradesView",
  components: {
    BreadCrumb,
    AcademicPerformanceGradesContent,
  },
});
